import React, { useContext, useEffect, useState } from "react";
import { JSDCContext, JSDCProvider } from "jsdc-dui/dist/JSDC/Context";
import JSDC from "jsdc-dui/dist/JSDC";
import { latLng, latLngBounds } from "leaflet";
import {
  IDuiContextProviderProps,
  DuiContextProvider,
  DuiContext,
} from "jsdc-dui/dist/components/Context";
import DguideWalksApp from "jsdc-dui/dist/components/DguideWalksApp";
import { DguidewalksProvider } from "jsdc-dui/dist/JSDC/Dguidewalks/Context";
import "jsdc-dui/dist/style/index.css";
// import './index.css'
import ConfigProvider from "jsdc-dui/dist/JSDC/Dguidewalks/ConfigProvider";
import kanban from "./assets/kanban.jpg";
import kanbanLg from "./assets/kanban-lg.jpg";
import MenuItemWithDialog from "jsdc-dui/dist/components/LeftMenuBar/MenuList/MenuItemWithDialog";
import Checkin from "jsdc-dui/dist/components/Icons/Checkin";
import "./index.scss";

const credit = `
<div>
    <ul>
        <li style="list-style-type: cjk-ideographic;">
        本圖臺是由國立臺北大學海山學研究中心、三鶯社區大學並與智紳數位文化有限公司共同協力建置。
            <br><br>1. 圖臺內容：國立臺北大學海山學研究中心、三鶯社區大學以及大海山地方學研究社文史工作者團隊共同撰稿、攝影。        
            <br><br>2. 圖臺系統開發：智紳數位文化事業有限公司
        </li>
        <br><br>
        <li style="list-style-type: cjk-ideographic;">
        本圖臺內容著作財產權由上述單位保有並授權國立臺北大學海山學研究中心、三鶯社區大學各項非商業行為使用，若有其他利用或授權需求請洽下列單位。
        </li>
    </ul>
</div>
國立臺北大學海山學研究中心 聯絡方式：02-86741111#66506<br>
三鶯`;

const duiConfigProps: IDuiContextProviderProps = {
  sidebarTitle: "穿越古樸的三層地區",
  sidebarSubtitle: "感受慈湖頭寮的好風水",
  aboutWalkImgSrc: kanban,
  aboutWalkContent:
    "穿越古樸的三層地區，沿北部橫貫公路往南，兩旁勁翠的綿延山嶺，隱藏著雙龍搶珠的風水寶地。來到頭寮，回顧林家大嵙崁奮鬥的痕跡─梅鶴山莊。在兩代蔣氏的長眠之地，感受慈湖頭寮的好風水。",
  credit,
  creditHref: "https://www.facebook.com/JRSHENDigitalCulture/",
  headerMBImgSrc: kanbanLg,
  headerDImgSrc: kanban,
  menuSwitchItems: [{ id: "數位集章", name: "數位集章" }],
  weatherConfig: {
    token: "CWB-232A270E-12F1-4381-B9F2-DF2D2670A077",
    locations: [
      { county: "桃園市", town: "大溪區" },
      { county: "桃園市", town: "龍潭區" },
    ],
  },
  themeConfig: {
    "--dui-primary": "#EA2A2A",
    "--dui-accent": "#EA2A2A",
    "--dui-secondary": "#F29882",
    "--dui-bg-secondary": "#EB9D1D",
    "--dui-bg-accent": "#F29882",
  },
  settingConfig: {
    disabled: true, // 左側選單不出現「工具設定」
    // languageSwitcherDisabled: true, // 或：保留「工具設定」，只藏語言切換器
  },
};

// 景點的 icon、點擊開集章卡片、集章 key、`?id=` 深連結、
// 列表的定位與導航、底圖、線都由 jsdc-dui 依 Strapi 的資料建立，這裡不需要再處理圖層。
function App() {
  const { Jsdc } = useContext(JSDCContext);
  const dui = useContext(DuiContext);

  useEffect(() => {
    (window as any).JSDC = Jsdc;
    dui.menuSwitch(undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="root">
      <DguideWalksApp
        language="zh-TW"
        mainMenuChildren={
          <MenuItemWithDialog
            Icon={Checkin}
            title="數位集章"
            active={dui.activeMenuId === "數位集章"}
            {...dui.menuSwitcherAction("數位集章")}
          >
            {dui.activeMenuId === "數位集章" && (
              <iframe
                title="數位集章"
                style={{ height: "100%", border: 0, borderRadius: "5px" }}
                src={
                  "https://map.jsdc.com.tw/tools/checkin/n0006/showlist.php?a=n0006"
                }
              ></iframe>
            )}
          </MenuItemWithDialog>
        }
      />
    </div>
  );
}

const eventId = "n0006";

const config = new ConfigProvider({ eventId });

const AppWrapper: React.FC = () => {
  const [Jsdc] = useState(
    new JSDC(eventId, {
      bound: latLngBounds(
        latLng(24.824365881555146, 121.25739097595216),
        latLng(24.892820908477518, 121.34167671203615),
      ),
      maxZoom: 19,
    }),
  );

  return (
    <JSDCProvider Jsdc={Jsdc}>
      <DguidewalksProvider Jsdc={Jsdc} config={config}>
        <DuiContextProvider
          {...duiConfigProps}
          // 沒有 cluster；列表定位的縮放層級是 17
          sceneConfig={{ cluster: false, targetZoom: 17 }}
        >
          <App />
        </DuiContextProvider>
      </DguidewalksProvider>
    </JSDCProvider>
  );
};

export default AppWrapper;
